import { render, staticRenderFns } from "./cansole.vue?vue&type=template&id=5510b94e&"
import script from "./cansole.vue?vue&type=script&lang=ts&"
export * from "./cansole.vue?vue&type=script&lang=ts&"
import style0 from "./cansole.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports